<script>
// import projectMemberModel from '@/model/projectMember';
import Access from '@/utils/access';
import utils from '@/utils/common';

import UserAvatar from '../UserAvatar.vue';
import EllipsisMenu from '../EllipsisMenu.vue';

export default {
  name: 'ProjectRow',
  components: { UserAvatar, EllipsisMenu },
  props: {
    project: Object,
  },
  computed: {
    dateStart() {
      return utils.convertDateToString(new Date(this.project.dateStart));
    },
    dateFinish() {
      return this.project.dateFinish ? utils.convertDateToString(new Date(this.project.dateFinish)) : '\u2013';
    },
    authorName() {
      return (this.project.author.name && this.project.author.surname) ? `${this.project.author.name} ${this.project.author.surname}` : this.project.author.email;
    },
    access() { return new Access(this.project, this.$store.state.auth.user); },
    userCanEdit() { return this.access.isProjectEditable && (this.access.isProjectAuthor() || this.access.isProjectAdmin()); },
    ellipsisMenuItems() {
      const items = [];

      // if (this.access.canEditProject()) {
      //   items.push({
      //     text: 'Редактировать',
      //     icon: 'edit',
      //     route: { name: 'project-edit', params: { projectId: this.project.id } },
      //   });
      // }
      //
      // if (!this.project.isArchived && this.access.canArchiveProject()) {
      //   items.push({
      //     text: 'В архив',
      //     icon: 'archive',
      //     handler: () => { this.$emit('archive', true); },
      //   });
      // }
      //
      // if (this.project.isArchived && this.access.canUnarchiveProject()) {
      //   items.push({
      //     text: 'Восстановить',
      //     icon: 'archive',
      //     handler: () => { this.$emit('archive', false); },
      //   });
      //   items.push({
      //     text: 'Удалить',
      //     icon: 'trash',
      //     handler: () => { this.$emit('delete', false); },
      //   });
      // }
      //
      // if (this.access.isProjectMember()) {
      //   items.push({
      //     text: 'Покинуть проект',
      //     icon: 'close3',
      //     handler: async () => {
      //       if (await projectMemberModel.leave(this.project)) {
      //         this.$router.go();
      //         console.log('leaved');
      //       } else {
      //         console.log('leaved not');
      //       }
      //     },
      //   });
      // }

      return items;
    },
  },
};
</script>

<template lang="pug">
  .project-frame(v-if="project")
    Bookmark(category="project" :id="project['@id']")
    .preview-container
      img.preview(v-if="project.avatar" :src="project.avatar.thumbnails.preview")
      Icon.preview(v-else :name="'no-avatar-project'")
    router-link.name(:to="{ name: 'project-stages', params: { projectId: project.id } }") {{ project.name }}
    .author-avatar-container
      UserAvatar(:user="project.author" :size="44" )
    .author-name {{ authorName }}
    .date {{ dateStart }}
    .date {{ dateFinish }}
    EllipsisMenu(:items="ellipsisMenuItems")
</template>

<style scoped lang="scss">
.project-frame {
  font-family: Geometria,sans-serif;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  padding: 14px;
  border-radius: 8px;

  .preview-container {
    min-width: 40px;
    height: 40px;
    margin: 0 13px 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;

    .preview {
      width: 40px;
      height: 40px;
      -o-object-fit: cover;
      object-fit: cover;
      border-radius: 8px;
    }
  }

  .name {
    min-width: 300px;
    max-width: 300px;
    margin-right: 10px;
    color: var(--color-dark-gray);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    max-height: 30px;
    overflow-y: hidden;
  }

  .author-avatar-container {
    width: 44px;
    height: 44px;
    margin-right: 14px;
  }

  .author-name {
    width: 300px;
    max-width: 350px;
    margin-right: 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: var(--color-accent);
    cursor: pointer;
  }

  .date {
    min-width: 110px;
    max-width: 110px;
    margin-right: 100px;
    color: var(--color-dark-gray);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    max-height: 44px;
  }
}
</style>
